// 此文件用户后台数据国际化
import Vue from "vue";

Vue.prototype.$langCase = langCase;
Vue.prototype.$domainCase = domainCase;
Vue.prototype.$roleCase = roleCase;
Vue.prototype.$supportFileSuffixes = Support_File_Suffixes;
Vue.prototype.getEnlang = function getEnlang (sourceLang = '', targetLang = '') {
  if (sourceLang && targetLang) {
    return `${this.$langCase[sourceLang]} - ${this.$langCase[targetLang]}`
  } else if (sourceLang && !targetLang) {
    return this.$langCase[sourceLang]
  } else {
    return ''
  }
}
Vue.prototype.getEnDomain = function getEnDomain (domainCode) {
  return this.$domainCase[domainCode]
}